import { render } from "./VideoScripts.vue?vue&type=template&id=e5d50d9a&scoped=true"
import script from "./VideoScripts.vue?vue&type=script&lang=js"
export * from "./VideoScripts.vue?vue&type=script&lang=js"

import "./VideoScripts.vue?vue&type=style&index=0&id=e5d50d9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5d50d9a"]])

export default __exports__